export const WOLF_FEEL_CONFIG = {
  maxSpeed: 548,
  acceleration: 5600,
  deceleration: 7200,
  lateralSpeed: 0.9,
  inputSmooth: 12,
  velocitySmooth: 22,
  rotationMaxDegrees: 5.5,
  rotationLerp: 13,
  cameraFollowLerp: 3.4,
  animationFps: 20,
  shadowOpacity: 0.46,
  shadowScale: 1.1,
  shadowOffsetY: 52,
  hitboxWidthRatio: 0.36,
  hitboxHeightRatio: 0.32,
  hitboxOffsetY: 10
} as const;
